module.exports = __webpack_public_path__ + "img/30.a6ccd050.jpg";